
import React from "react";
import {
    FaYoutube,
    FaInstagram,
    FaWhatsapp,
    FaFacebook,
    FaTelegram,
    FaChevronRight,
} from "react-icons/fa";
import { FaThreads } from "react-icons/fa6";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const CreatorProfilePage = () => {
    const courses = [
        {
            title: "Chat GPT Prompt Writing 101",
            link: "https://learn.nextfutureai.in/services/promptwriting101",
            description: "Learn AI-driven ads.",
            image:
                "/images/profilepage/chatgpt_prompt_writing_101.jpg",
        },
        {
            title: "AI 3D Animation Mastery",
            link: "https://learn.nextfutureai.in/services/3dcourse",
            description: "Build smart chatbots.",
            image:
                "/images/profilepage/ai_3d_animation_mastery.jpg",
        },
        {
            title: "ChatGPT Ad Image Mastery",
            link: "https://satyamai.rpy.club/course/FKoQLRZ2Fe",
            description: "Master AI video tools.",
            image:
                "/images/profilepage/chatgpt_ad_image_mastery.jpg",
        },
        {
            title: "CGI Ads Mastery with AI",
            link: "https://learn.nextfutureai.in/services/aicgimastery",
            description: "Create CGI ads using AI.",
            image:
                "/images/profilepage/cgi_ad_mastery.jpg",
        },
    ];

    return (
        <div className="min-h-screen bg-gray-100 flex justify-center p-4">
            <div className="w-full max-w-3xl">
                {/* Profile Box */}
                <div className="bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-2xl shadow-lg p-6 text-center text-white">
                    <img
                        // src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNp4BiCNieWJ67R5TvIJADDkVIOpK8SmuM5A&s"
                        src="./images/profilepage/satyam_ai_profile.jpg"
                        alt="Profile"
                        className="w-28 h-28 mx-auto rounded-full border-4 border-white shadow-md"
                    />
                    <h1 className="text-2xl font-bold mt-4">Satyam AI</h1>
                    <p className="text-sm opacity-90">AI Course Creator | Educator</p>
                </div>

                {/* Courses Slider */}
                <div className="mt-6">
                  
                    <Swiper
                        modules={[Autoplay]}
                        spaceBetween={12}
                        loop={true}
                        autoplay={{ delay: 2500, disableOnInteraction: false }}
                        breakpoints={{
                            0: { slidesPerView: 2 },      // 📱 Mobile: 2 cards
                            640: { slidesPerView: 2 },    // 📲 Tablet: 2 cards
                            1024: { slidesPerView: 3 },   // 💻 Desktop: 3 cards
                        }}
                    >
                        {courses.map((course, idx) => (
                            <SwiperSlide key={idx} className="!h-auto flex mb-1">
                             
                                <a
                                    href={course.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block w-full h-full"
                                >
                                    <div className="bg-white rounded-xl shadow hover:shadow-md transition overflow-hidden flex flex-col w-full h-full cursor-pointer">
                                        <img
                                            src={course.image}
                                            alt={course.title}
                                            className="w-full h-28 lg:h-32 object-cover"
                                        />
                                        <div className="p-3 flex flex-col flex-grow justify-between">
                                            <h3 className="font-bold text-sm text-gray-900 line-clamp-2">
                                                {course.title}
                                            </h3>
                                            <span className="text-indigo-600 text-sm font-medium mt-2">
                                                View Course →
                                            </span>
                                        </div>
                                    </div>
                                </a>

                            </SwiperSlide>
                        ))}
                    </Swiper>

                </div>


                <div className="mt-5 space-y-3">
                    <a
                        href="https://www.youtube.com/@SatyamTechInsights"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-between bg-white p-3 rounded-lg shadow hover:shadow-md transition cursor-pointer"
                    >
                        <div className="flex items-center">
                            <FaYoutube className="text-red-500 text-2xl mr-3" />
                            <span className="text-gray-700">Subscribe on <b>YouTube</b></span>
                        </div>
                        <FaChevronRight className="text-gray-400" />
                    </a>

                    <a
                        href="https://www.instagram.com/satyamtechinsights/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-between bg-white p-3 rounded-lg shadow hover:shadow-md transition cursor-pointer"
                    >
                        <div className="flex items-center">
                            <FaInstagram className="text-pink-500 text-2xl mr-3" />
                            <span className="text-gray-700">Follow me on <b>Instagram</b></span>
                        </div>
                        <FaChevronRight className="text-gray-400" />
                    </a>

                    <a
                        href="https://www.facebook.com/satyamtechinsights"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-between bg-white p-3 rounded-lg shadow hover:shadow-md transition cursor-pointer"
                    >
                        <div className="flex items-center">
                            <FaFacebook className="text-blue-600 text-2xl mr-3" />
                            <span className="text-gray-700">Follow on <b>Facebook</b></span>
                        </div>
                        <FaChevronRight className="text-gray-400" />
                    </a>

                    <a
                        href="https://www.whatsapp.com/channel/0029Vb5TDJXHbFUy2QPDL442"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-between bg-white p-3 rounded-lg shadow hover:shadow-md transition cursor-pointer"
                    >
                        <div className="flex items-center">
                            <FaWhatsapp className="text-green-500 text-2xl mr-3" />
                            <span className="text-gray-700">Chat with me on <b>WhatsApp</b></span>
                        </div>
                        <FaChevronRight className="text-gray-400" />
                    </a>

                    <a
                        href="https://t.me/+7kjQsrSXmPc3OTll"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-between bg-white p-3 rounded-lg shadow hover:shadow-md transition cursor-pointer"
                    >
                        <div className="flex items-center">
                            <FaTelegram className="text-sky-500 text-2xl mr-3" />
                            <span className="text-gray-700">Join my <b>Telegram</b> channel</span>
                        </div>
                        <FaChevronRight className="text-gray-400" />
                    </a>

                    <a
                        href="https://www.threads.com/@satyamtechinsights"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center justify-between bg-white p-3 rounded-lg shadow hover:shadow-md transition cursor-pointer"
                    >
                        <div className="flex items-center">
                            <FaThreads className="text-black text-2xl mr-3" />
                            <span className="text-gray-700">Connect on <b>Threads</b></span>
                        </div>
                        <FaChevronRight className="text-gray-400" />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default CreatorProfilePage;
